<template>
  <artmisads-table :columns="columns" row-key="id" :scroll="{ x:props.activeTab=='0'? 1300:'auto' }" :data-source="tableDataList" :pagination="{
    total: tableParams.total,
    current: tableParams.page,
    pageSize: tableParams.size,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '50', '100', '200']
  }" :change="onChangePage" rowClassName="table-item" :loading="loading">
    <template #bodyCell="{ column, text, record }">
      <template v-if="column.name === 'showCurrency'">
        {{ text ? AMAZON_CURRENCY_MAPPER[props.marketplace] : '' }}{{ text }}
      </template>
      <template v-if="column.name === 'reportDateTimestamp'">
        {{ moment(text).format('YYYY-MM-DD') }}
      </template>
      <!-- <template v-if="column.name === 'more'">
          <svg @click="() => onClickTableChart(record)" class="icon chart-icon" aria-hidden="true">
            <use xlink:href="#icon-chart"></use>
          </svg>
        </template> -->
      <template v-if="column.name === 'ACOS'">
        {{ text ? (text * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1') + '%' : '0' }}
      </template>
      <template v-if="column.name === 'publisherName'">
        <div class="brand-title">
          <!-- <a class="brand-title"  target="_blank" :href="`/seller/brand/detail/${record.publisherId}`">   -->
          <div class="brand-img-show" :style="record?.publisherHeadImageUrl ? { 'background': '#ffffff' } : ''">
            <img :src="record.publisherHeadImageUrl" alt="" v-if="record.publisherHeadImageUrl">
          </div>
          <div class="brand-font">
            <span>{{ record.publisherName }}</span>
          </div>
        </div>
      </template>
      <template v-if="column.name === 'brandName'">
          <!-- :href="`/seller/brand/detail/${record.brandId}`" -->
          <a class="brand-title" target="_blank" >
            <div class="brand-img-show" :style="record?.brandLogoImageUrl ? { 'background': '#ffffff' } : ''">
              <img :src="record.brandLogoImageUrl" v-if="record.brandLogoImageUrl">
              <span class="brand-name" v-else>{{ record.brandName }}</span>
            </div>
            <div class="brand-font">
              <span >{{ record.brandName }}</span>
            </div>
          </a>
        </template>
    </template>
  </artmisads-table>
</template>
<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import { AMAZON_CURRENCY_MAPPER } from '~/contants/common'
import { publisherAdminApi } from '~/server/index'
import { useSellerI18n } from '@/composables/useSellerI18n'
import { reportsApi } from '~/server/index'


import moment from 'moment'

const { st } = useSellerI18n()

const loading = ref(true)
const props = defineProps({
  pageType: {
    type: String,
    default: ''
  },
  marketplace: {
    type: String,
    default: 'amazon.com'
  },
  itemInfo: {
    type: Object,
    default: () => ({})
  },
  activeTab: {
    type: String,
    default: '0'
  },
  params: {
    type: Object,
    default: () => ({})
  },
})
const tableDataList = ref([])
const tableParams = ref({
  size: 10,
  page: 1,
  total: 50,
  sortField: '',
  sortDirection: '',
})
 watch([() => props.params.startReportDateTimestamp, () => props.params.endReportDateTimestamp], async () => {
    tableParams.value = {
    size: 10,
    page: 1,
    total: 50,
    sortField: '',
    sortDirection: '',
  }
  getList()
  },{deep:true});

const onChangePage = (data, filters, sorter) => {
  const { current, pageSize } = data
  tableParams.value.page = current
  tableParams.value.size = pageSize
  tableParams.value.pageSize = pageSize
   if (sorter) {
    const { field, order } = sorter
    tableParams.value.sortField = field
    tableParams.value.sortDirection = order === 'ascend' ? 'asc' : 'desc'
  } else {
    tableParams.value.sortField = ''
    tableParams.value.sortDirection = ''
  }
  getList()
  //  getData({ page: current, size: pageSize })
}

const metricColumnsAttribution = () => [
  {
    title: st('reports.performanceTable.dpvs'),
    dataIndex: 'detailPageViews',
    width: 80,
    sorter: true,
  },
  {
    title: st('reports.performanceTable.addToCart'),
    dataIndex: 'addToCart',
    width: 130,
    sorter: true,
  },
  {
    title: st('reports.performanceTable.conversions'),
    dataIndex: 'conversions',
    width: 120,
    sorter: true,
  },
  {
    title: st('reports.performanceTable.sales'),
    dataIndex: 'salesAmount',
    name: 'showCurrency',
    width: 100,
    sorter: true,
  },
  {
    name: 'ACOS',
    title: st('reports.performanceTable.acos'),
    dataIndex: 'acos',
    width: 100,
    sorter: true,
  },
  {
    title: st('reports.performanceTable.salesForCommission'),
    dataIndex: 'discountedSalesAmount',
    name: 'showCurrency',
    width: 200,
    sorter: true,
  },
  {
    title: st('reports.performanceTable.commission'),
    dataIndex: 'commissionAndFeeAmount',
    name: 'showCurrency',
    width: 120,
    sorter: true,
  },
]

const columns = computed(() => {
  const tab = props.activeTab
  const pt = props.pageType
  if (tab === '0') {
    if (pt === 'operatorBrand'|pt === 'sellerBrand') {
      return [
        {
          title: st('reports.filterBar.publisher'),
          dataIndex: 'publisherName',
          name: 'publisherName',
          width: 170,
          fixed: 'left',
        },
        ...metricColumnsAttribution(),
      ]
    }
    if (pt === 'operatorPublisher'|pt === 'sellerPublisher') {
      return [
        {
          title: st('reports.filterBar.brand'),
          dataIndex: 'brandName',
          name: 'brandName',
          width: 170,
          fixed: 'left',
        },
        ...metricColumnsAttribution(),
      ]
    }
  } else {
    if (pt === 'operatorBrand'|pt === 'sellerBrand') {
      return [
        {
          title: st('reports.filterBar.publisher'),
          dataIndex: 'publisherName',
          name: 'publisherName',
          fixed: 'left',
        },
        {
          title: st('reports.performanceTable.quantity'),
          dataIndex: 'quantity',
          sorter: true,
        },
        {
          title: st('reports.performanceTable.sales'),
          dataIndex: 'salesAmount',
          name: 'showCurrency',
          sorter: true,
        },
        {
          title: st('reports.performanceTable.commission'),
          dataIndex: 'commissionAndFeeAmount',
          name: 'showCurrency',
          sorter: true,
        },
        {
          title: st('reports.performanceTable.adjustedCommissionByAcc'),
          dataIndex: 'finalCommissionAndFeeAmount',
          name: 'showCurrency',
          sorter: true,
        },
      ]
    }
    if (pt === 'operatorPublisher'|pt === 'sellerPublisher') {
      return [
        {
          title: st('reports.filterBar.brand'),
          dataIndex: 'brandName',
          name: 'brandName',
        },
        {
          title: st('reports.performanceTable.quantity'),
          dataIndex: 'quantity',
          sorter: true,
        },
        {
          title: st('reports.performanceTable.sales'),
          dataIndex: 'salesAmount',
          name: 'showCurrency',
          sorter: true,
        },
        {
          title: st('reports.performanceTable.commission'),
          dataIndex: 'commissionAndFeeAmount',
          name: 'showCurrency',
          sorter: true,
        },
        {
          title: st('reports.performanceTable.adjustedCommissionByAcc'),
          dataIndex: 'finalCommissionAndFeeAmount',
          name: 'showCurrency',
          sorter: true,
        },
      ]
    }
  }
  return [
    {
      title: st('reports.filterBar.publisher'),
      dataIndex: 'publisherName',
      name: 'publisherName',
      width: 170,
      fixed: 'left',
    },
    ...metricColumnsAttribution(),
  ]
})

const getList = async () => {
  loading.value = true
  const newparams = {
    ...tableParams.value,
    marketplace: props.marketplace,
    startReportDateTimestamp:  props.params.startReportDateTimestamp || moment().subtract(1, 'month').valueOf(),
    endReportDateTimestamp:  props.params.endReportDateTimestamp || moment().valueOf(),
    brandId: props.itemInfo.brandId || undefined,
    publisherId: props.itemInfo.publisherId || undefined,
  }
  let res = ''
  if (props.activeTab == '0') {
    if (props.pageType == 'operatorBrand') {
      res = await publisherAdminApi.commissionReportsPublisher(newparams)
    }
    if (props.pageType == 'operatorPublisher') {
      res = await publisherAdminApi.commissionReportsBrand(newparams)
    }
    if (props.pageType == 'sellerBrand') {
      const resData = await reportsApi.getSellerCommissionReportsPublisher(newparams)
      res = resData.data
    }
    if(props.pageType == 'sellerPublisher') {
      const resData  = await reportsApi.getSellerCommissionReportsBrand(newparams)
      res = resData.data
    }
    if (res) {
    tableDataList.value = res.data
    tableParams.value.total = res.total

  }
  } else {
    if(props.pageType == 'operatorBrand'){
       res = await publisherAdminApi.commissionReportsPublisherAssociate(newparams)
    }
    if(props.pageType == 'operatorPublisher'){
      res = await publisherAdminApi.commissionReportsBrandAssociate(newparams)
    }
    if (props.pageType == 'sellerBrand') {
      const resData = await reportsApi.getSellerCommissionReportsPublisherAssociate(newparams)
      res = resData.data
    }
    if(props.pageType == 'sellerPublisher') {
      const resData  = await reportsApi.getSellerCommissionReportsBrandAssociate(newparams)
      res = resData.data
    }
    const { success, data } = res
    if (success) {
      tableDataList.value = data.data
      tableParams.value.total = data.total
    }
  }
  loading.value = false
  // const { success, data } = res
  

}
onMounted(() => {
  getList()
})
</script>
<style lang="less" scoped>
.brand-title {
  display: flex;
  align-items: center;
   .brand-name {
        margin: 0 auto;
        padding: 0 4px;
        max-width: 56px;
        font-size: 11px;
        overflow: hidden;
        max-height: 39px;
        font-weight: 600;
        line-height: 13px;
        text-align: center;
        color: var(--dark-4);
        letter-spacing: 0.3px;
      }
  .brand-font {
    word-break: break-all;
    flex: 1;
    margin-left: 12px;
    font-weight: 500;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 22px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    // text-decoration: underline;
  }

  .brand-img-show {
    width: 56px;
    height: 56px;
    background: var(--bg-gray-2);
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    :deep(img) {
      border-radius: 8px;
      height: 56px;

      object-fit: contain;
    }
  }

}
</style>
